// ENTITY com.ic2.entity.User generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class User {

  static readonly __ic2_fqn: string = 'com.ic2.entity.User';

  idUser: number | null = 0;
  login: string | null = '';
  password: string | null = '';
  email: string | null = '';
  firstName: string | null = '';
  lastName: string | null = '';
  loginAttemptsFailed: number | null = 0;
  lockedUntil: Date | null = null;
  del: boolean | null = false;

  constructor(init?:Partial<User>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['com.ic2.entity.User'] = User;

fields['com.ic2.entity.User']  = {
    idUser: 'java.lang.Integer',
    login: 'java.lang.String',
    password: 'java.lang.String',
    email: 'java.lang.String',
    firstName: 'java.lang.String',
    lastName: 'java.lang.String',
    loginAttemptsFailed: 'java.lang.Integer',
    lockedUntil: 'java.time.Instant',
    del: 'java.lang.Boolean'
};
